import { SET_MIXCLOUD_SLUG } from '../reducers/reducers'

export const setMixcloudSlug = (slug) => {
    return {
        type: SET_MIXCLOUD_SLUG,
        payload: slug,
    };
};